import { RouteUrls, UrlsEnum } from '@lentau/ui-kit/core/enums/route.enum';
import { Routes } from '@angular/router';

export const OLD_ROUTES: Routes = [
  { path: RouteUrls.OrderCartOld, redirectTo: UrlsEnum.BasketPage, pathMatch: 'full' },
  { path: RouteUrls.OrderCheckoutOld, redirectTo: UrlsEnum.BasketPage, pathMatch: 'full' },
  { path: RouteUrls.OrderTypePage, redirectTo: UrlsEnum.Orders, pathMatch: 'full' },
  { path: RouteUrls.OrderTypeZakaz, redirectTo: UrlsEnum.Orders, pathMatch: 'full' },
];
